import { call, put, takeLatest } from 'redux-saga/effects';
import * as type from '../constants/actionConstants';
import * as actions from '../actions/LoyaltyAccountInfoAction.js';
import {
getAllWithImageServ,
  getGiftInforsServ,
  getAllQuestServ,
  getAllRewardServ,
  getGiftDetailByGroupServ,
getListMyGiftStore,
  onSearchChallengeDetailServ,
  getProfileByCServ,
  getRedeemTokenServ,
  getSearchTransactionDetailServ,
getByGiftGroupServ,
  getQuestAllServ,
  getListMyGiftGroupStore,
} from '../services/LoyaltyAccountInfoService';
import { setLocalGiftGroupCodeFilter, isSuccess, getLocalGiftGroupCodeFilter } from '../../functions';
import { RoutesV1 } from 'constants/appRoutes';
import { getGiftGroupCodeFilter } from 'model/services/LoginService';

export function* getListMyGiftGroupStoreAction({ payload }) {
  let giftGroupCodeFilter = getLocalGiftGroupCodeFilter()
  try {
    if(!giftGroupCodeFilter){
      const response = yield call(getGiftGroupCodeFilter, {})
      setLocalGiftGroupCodeFilter(response.data.sysValue)
      giftGroupCodeFilter = response.data.sysValue
    }
    const repos = yield call(getListMyGiftGroupStore, {...payload, giftGroupCodeFilter: giftGroupCodeFilter});
    yield put(actions.getListMyGiftGroupStoreActionSuccess(repos));
  } catch (err) {}
}

export function* getQuestAll({ payload }) {
  try {
    const repos = yield call(getQuestAllServ, payload);
    if (isSuccess(repos.responseStatus)) {
      yield put(actions.getQuestAllActionSuccess(repos));
    } else {
    }
  } catch (err) {
    yield put(actions.getAllQuestErr(err));
  }
}

export function* getProfileByC({ payload }) {
  try {
    const repos = yield call(getProfileByCServ, payload);
    yield put(actions.getProfileByCSuccess(repos));
  } catch (err) {
    yield put(actions.getProfileByCErr(err));
  }
}

export function* getListMyGiftStoreAction({ payload }) {
  try {
    const repos = yield call(getListMyGiftStore, payload);
    if (isSuccess(repos.responseStatus)) {
      yield put(actions.getListMyGiftStoreActionSuccess(repos));
    } else {
    }
  } catch (err) {
    yield put(actions.getListMyGiftStoreActionErr(err));
  }
}

export function* getRedeemToken({ payload }) {
  try {
    const repos = yield call(getRedeemTokenServ, payload);
    // if (isSuccess(repos.responseStatus)) {
      yield put(actions.getRedeemTokenSuccess(repos));
    // } else {
    // }
  } catch (err) {
    yield put(actions.getRedeemTokenErr(err));
  }
}

export function* onClickScrollingMenu({ payload }) {
  try {
    const repos = yield call(onSearchChallengeDetailServ, payload);
    yield put(actions.onClickScrollingMenuSuccess(repos));
    if (isSuccess(repos.responseStatus)) {
      if (repos.obj.group) {
        window.location.href = RoutesV1.groupProduct;
      } else if (repos.obj.account) {
        window.location.href = '/pages/scrolling-menu';
      }
    }
  } catch (err) {
    yield put(actions.onClickScrollingMenuErr(err));
  }
}

export function* getGiftDetailByGroupAction({ payload }) {
  try {
    const repos = yield call(getGiftDetailByGroupServ, payload);
    yield put(actions.getGiftDetailByGroupActionSuccess(repos));
  } catch (err) {
    yield put(actions.getGiftDetailByGroupAction(err));
  }
}

export function* onSearchChallengeDetail({ payload }) {
  try {
    const repos = yield call(onSearchChallengeDetailServ, payload);
    yield put(actions.onSearchChallengeDetailSuccess(repos));
    if (isSuccess(repos.responseStatus)) {
      if (repos.obj.group) {
        window.location.href = RoutesV1.groupProduct;
      } else if (repos.obj.account) {
        window.location.href = '/pages/challenge-detail';
      }
    }
  } catch (err) {
    yield put(actions.onSearchChallengeDetailErr(err));
  }
}

export function* onSearchTransactionDetail({ payload }) {
  try {
    const repos = yield call(getSearchTransactionDetailServ, payload);
    yield put(actions.onSearchTransactionDetailSuccess(repos));
  } catch (err) {
    yield put(actions.onSearchTransactionDetailErr(err));
  }
}

export function* getAllQuest({ payload }) {
  try {
    const repos = yield call(getAllQuestServ, payload);
    yield put(actions.getAllQuestSuccess(repos));
  } catch (err) {
    yield put(actions.getAllQuestErr(err));
  }
}

export function* getAllReward({ payload }) {
  try {
    const repos = yield call(getAllRewardServ, payload);
    yield put(actions.getAllRewardSuccess(repos));
  } catch (err) {
    yield put(actions.getAllRewardErr(err));
  }
}

export function* getByGiftGroup({ payload }) {
  try {
    const repos = yield call(getByGiftGroupServ, payload);
    yield put(actions.getByGiftGroupSuccess(repos));
  } catch (err) {
    yield put(actions.getByGiftGroupErr(err));
  }
}

export function* getGiftInfors({ payload }) {
  try {
    const repos = yield call(getGiftInforsServ, payload);
    yield put(actions.getGiftInforsSuccess(repos));
  } catch (err) {
    yield put(actions.getGiftInforsErr(err));
  }
}
//

export function* getAllWithImage({ payload }) {
  try {
    const repos = yield call(getAllWithImageServ, payload);
    yield put(actions.getAllWithImageSuccess(repos));
  } catch (err) {
    yield put(actions.getAllWithImageErr(err));
  }
}

export const loyaltyAccountInfo = [
takeLatest(type.loyaltyAccInfoConst.CHALLENGE_DETAIL, onSearchChallengeDetail),
  takeLatest(type.loyaltyAccInfoConst.GET_LOYALTY_TRANSACTION, onSearchTransactionDetail),
  takeLatest(type.loyaltyAccInfoConst.GET_LOYALTY_CHALLENGE, getAllQuest),
  takeLatest(type.loyaltyAccInfoConst.GET_LOYALTY_REWARD, getAllReward),
takeLatest(type.loyaltyAccInfoConst.GET_LOYALTY_GIFTGROUP, getByGiftGroup),
  takeLatest(type.loyaltyAccInfoConst.GET_LOYALTY_GIFTINFORS, getGiftInfors),
takeLatest(type.loyaltyAccInfoConst.GIFT_GETALL_GETALLWITHIMAGE, getAllWithImage),
  takeLatest(type.loyaltyAccInfoConst.GIFT_GROUPDETAIL_GIFTGROUP, getGiftDetailByGroupAction),
takeLatest(type.loyaltyAccInfoConst.GIFT_QUEST_GETALL, getQuestAll),
  takeLatest(type.loyaltyAccInfoConst.GET_LOYALTY_GETPROFILEBYC, getProfileByC),
  takeLatest(type.loyaltyAccInfoConst.STORE_GIFT_GETALL_BYMEMBERCODE, getRedeemToken),
  takeLatest(type.loyaltyAccInfoConst.GET_LOYALTY_FUNCTION_SUPPORT, onClickScrollingMenu),
  takeLatest(type.loyaltyAccInfoConst.STORE_GIFT_GETALL_BYGROUPCODE, getListMyGiftGroupStoreAction),
];
